// extracted by mini-css-extract-plugin
export default {"logincentre":"Signup_logincentre__cSRF+","logincard":"Signup_logincard__Iy6Ic","loginbanner":"Signup_loginbanner__G07rF","loginph":"Signup_loginph__h7wX7"};